var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4725 11.1602H5V24.7109H9.4725V11.1602Z",
    fill: "#1E1B2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.655 11.3191C21.6075 11.3043 21.5625 11.2883 21.5125 11.2747C21.4525 11.2612 21.3925 11.2501 21.3312 11.2402C21.0937 11.1934 20.8338 11.1602 20.5288 11.1602C17.9213 11.1602 16.2675 13.0289 15.7225 13.7508V11.1602H11.25V24.7109H15.7225V17.3196C15.7225 17.3196 19.1025 12.6803 20.5288 16.0877C20.5288 19.1293 20.5288 24.7109 20.5288 24.7109H25V15.5666C25 13.5192 23.5763 11.8131 21.655 11.3191Z",
    fill: "#1E1B2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1875 9.31159C8.39562 9.31159 9.375 8.34641 9.375 7.1558C9.375 5.96518 8.39562 5 7.1875 5C5.97938 5 5 5.96518 5 7.1558C5 8.34641 5.97938 9.31159 7.1875 9.31159Z",
    fill: "#1E1B2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.1b8fab05473cafbcddd49f2ed0fbdd10.svg";
export { ForwardRef as ReactComponent };